import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  background: url("https://source.unsplash.com/random");
  background-position: center;
  background-size: cover;
  position: absolute;
  z-index: -1;
`;
